
export default {
  props: {
    gallery: {
      type: Boolean,
      default: false,
    },
  },
}
